// extracted by mini-css-extract-plugin
export default {"root":"G_VuCV","wired":"w66taC","spinner":"qJHs3V","no-wrap":"k5LcBN","noWrap":"k5LcBN"};